import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconMenuClose = forwardRef<SVGSVGElement, IconProps>(
  function IconClose(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses = "w-8 h-8 focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        className={classes}
        {...otherProps}
      >
        <path
          d="M26.9424 6.3918C26.9424 6.3918 25 8.21289 22.5 10.7129C20 13.2129 17.0208 17.0205 17.0208 17.0205L8.53553 24.0916L6.39212 26.9421C6.30421 27.03 6.18265 27.0771 6.05419 27.0729C5.92572 27.0688 5.80087 27.0138 5.70711 26.92C5.61334 26.8262 5.55833 26.7014 5.55419 26.5729C5.55004 26.4445 5.5971 26.3229 5.68501 26.235L7.82843 23.3845L15.9722 16.1549C15.9722 16.1549 19.0858 12.7987 21.7929 10.0058C24.5 7.21289 26.2353 5.6847 26.2353 5.6847C26.3232 5.59679 26.4448 5.54973 26.5732 5.55388C26.7017 5.55802 26.8265 5.61303 26.9203 5.70679C27.0141 5.80056 27.0691 5.92541 27.0732 6.05388C27.0774 6.18234 27.0303 6.3039 26.9424 6.3918Z"
          fill="currentColor"
        />
        <path
          d="M27.0684 26.3754C27.0684 26.3754 25.126 24.5543 22.626 22.0543C20.126 19.5543 16.9203 15.6064 16.9203 15.6064L12.6068 12.0065L6.29157 5.68481C6.20367 5.59691 6.08211 5.54985 5.95365 5.55399C5.82518 5.55814 5.70033 5.61314 5.60657 5.70691C5.5128 5.80068 5.45779 5.92553 5.45365 6.05399C5.4495 6.18246 5.49656 6.30401 5.58447 6.39192C5.58447 6.39192 9.89923 11.2131 11.3994 12.7129C12.8996 14.2127 15.8716 16.472 15.8716 16.472C15.8716 16.472 19.2118 19.9685 21.9189 22.7614C24.626 25.5543 26.3613 27.0825 26.3613 27.0825C26.4492 27.1704 26.5708 27.2174 26.6993 27.2133C26.8277 27.2092 26.9526 27.1542 27.0463 27.0604C27.1401 26.9666 27.1951 26.8418 27.1993 26.7133C27.2034 26.5848 27.1563 26.4633 27.0684 26.3754Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
